"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'FilterItem',
  props: {
    item: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    initValue: {
      type: [Array, Number, String]
    }
  },
  watch: {
    initValue: {
      handler: function handler(initValue) {
        initValue && (this.itemProp = initValue);
      },
      immediate: true
    }
  },
  data: function data() {
    return {
      itemProp: this.item.defaultValue || '',
      isLoaded: false
    };
  },
  mounted: function mounted() {
    if (this.item.async && this.item.load) {
      this.item.load(this.item);
    }
  },
  methods: {
    reset: function reset() {
      this.itemProp = this.item.defaultValue || '';
    },
    initChange: function initChange(value) {
      this.itemProp = value;
    },
    handleSelectFocus: function handleSelectFocus() {
      var _this = this;
      if (this.item.async && !this.isLoaded && this.item.load) {
        this.item.load(this.item).then(function () {
          _this.isLoaded = true;
        });
      }
    }
  }
};